import { render, staticRenderFns } from "./TableChart.vue?vue&type=template&id=07569ac4&scoped=true"
import script from "./TableChart.vue?vue&type=script&lang=js"
export * from "./TableChart.vue?vue&type=script&lang=js"
import style0 from "./TableChart.vue?vue&type=style&index=0&id=07569ac4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07569ac4",
  null
  
)

export default component.exports